
import { Component, Vue } from "vue-property-decorator";

@Component
export default class MoqupStock extends Vue {

  private headers = [
    {value: "name", text: "Nom"},
    {value: "used", text: "Utilisation"},
    {value: "stock", text: "Stock"},
  ];
  private items = [
    {
      name: "PASSE GENERAL ",
      used: 9,
      stock: 3,
    },
    {
      name: "PASSE GENERAL T",
      used: 1,
      stock: 1,
    },
    {
      name: "PASSE G CLIM PLOMBERIE",
      used: 4,
      stock: 0,
    },
    {
      name: "T04-134 - CLE",
      used: 0,
      stock: 2,
    },
    // {
    //   name: "T04-134 - CANON",
    //   used: 1,
    //   stock: 1,
    // },
    {
      name: "SECOURS - CLE",
      used: 1,
      stock: 1,
    },
    // {
    //   name: "SECOURS - CANON",
    //   used: 1,
    //   stock: 1,
    // },
  ];

  private progressValue = (a, b) => a * 100 / (a + b);

  private colorValue = (progressValue) => progressValue === 100 ? "red" : "orange";
}
